import {
  DetailItemA,
  HeadTitle,
  ItemContent,
  SegmentButtons,
  Spacer,
  Button,
  Divider,
  SpacerSection,
  TheFooter,
  Icon,
  CheckboxBottomsheet,
  Bottomsheet,
  BridgeModal,
  Trg16,
  Tmd14,
  Trg11,
  Skeleton,
  Popup,
  TextButton,
  TheSliderFilterBottomsheet,
} from 'oui';
import {
  FlexBox,
  DefaultBox,
  CenterBox,
  IconBox,
  VisualBox,
} from '../../etc/LBox/LBox';
import FAQ from '../../../application/staticData/info/FAQ';
import rateImg from '../../../assets/images/feature/feature-mtg-visual3.png';
import { useMtgResult } from '../../../application/bloc/useMtgResult';
import { AccordionList } from '../../etc/Accordion/AccordionList';
import { Wrap } from '../../etc/Accordion/Accordion.styled';
import InfoTable from '../../dataDisplay/InfoTable/InfoTable';
import useFooter from '../../../application/hooks/useFooter';
import EmptyResultMtg from '../../etc/EmptyResult/EmptyResultMtg';
import { ClkBtnSubEventNm } from '../../../application/hooks/useBeacon';
import { addUnitToMaxAmount } from '../../../application/helper/filter';

import { useRecoilState } from 'recoil';
import * as Atom from '../../../application/recoil';
import TermFullSheet from '../../feedback/TermFullSheet/TermFullSheet';
import StackingSnackbar from '../../component/StackingSnackbar/StackingSnackbar';
import moment from 'moment';

export const MtgResult = () => {
  const { navigateOvertake, navigateOvertakePrivacy, navigateOnlineLoanCorp } =
    useFooter();
  const {
    hasResult,
    isLoading,
    isOpenFilter,
    filterValue,
    media,
    mtgSummary,
    filteredList,

    mtgInfo,
    popup,
    sortValue,

    openBottomsheet,
    setSortValue,

    termBottomsheet,
    termFullsheet,
    openTermFullsheet,
    onClickSubText,

    creditTermFullsheet,
    creditTermBottomsheet,
    openCreditTermFullsheet,
    onClickCreditSubText,
    processCreditTerm,

    bottomsheet,
    regDate,
    isBridgeModal,
    terms,

    navigateSurvey,
    navigateDetail,
    navigateDA,
    navigatePurpose,
    navigateCredit,
    navigateCreditCond,

    sendBeaconClkBtnAgree,
    sendBeaconClkBtn,

    setOpenFilter,
    setFilterValue,

    setShouldBlock,
  } = useMtgResult();

  const [, setMortgageInfo] = useRecoilState(Atom.mortgageInfo);

  const onClickMaxAmt = () => {
    openBottomsheet('예상 한도는 이렇게 계산해요');
  };

  const onClickRePreReq = async () => {
    setMortgageInfo(Atom.createDefaultMortgageInfo());
    sendBeaconClkBtn(ClkBtnSubEventNm.ReResucc, '다른 담보로 다시 조회하기'); // todo 가심가 결과에 따라 문구 변경
    if (media === 'lgu') {
      await terms.processAgreeTermLgu2(() => {
        setShouldBlock(false);
        setFilterValue({
          limit: 0,
          interest: 20,
        });
        navigatePurpose();
      });
    } else {
      termBottomsheet.open();
    }
  };

  const onClickCreBtn = () => {
    setShouldBlock(false);
    setMortgageInfo(Atom.createDefaultMortgageInfo());
    sendBeaconClkBtn('credit', '신용대출 비교');
    setTimeout(() => {
      navigateCredit();
    }, 100);
  };

  const onClickMtgInfo = () => {
    openBottomsheet('담보 정보');
    sendBeaconClkBtn(ClkBtnSubEventNm.MyMtgInfo, '담보 정보 확인하기');
  };
  const onClickSurvey = () => {
    navigateSurvey();
  };
  const handleClickAllProduct = (val: number) => {
    sendBeaconClkBtn(ClkBtnSubEventNm.Product, {
      product_name: filteredList[val].productNm,
    });
    setShouldBlock(false);
    setTimeout(() => {
      navigateDetail(
        filteredList[val]?.requestSeq,
        filteredList[val]?.preRequestDtlNo,
      );
    }, 100);
  };
  const handleClickTermCta = async (e: any) => {
    setShouldBlock(false);
    setFilterValue({
      limit: 0,
      interest: 20,
    });
    sendBeaconClkBtnAgree(e.target.innerHTML);
    setTimeout(() => {
      terms.processAgreeTermAndNavigate(`/mtg/conditions/1`, {
        state: { ref_page: '/mtg/result' },
      });
    }, 100);
  };

  const handleClickCreditTermCta = async (e: any) => {
    setShouldBlock(false);
    setFilterValue({
      limit: 0,
      interest: 20,
    });
    sendBeaconClkBtnAgree(e.target.innerHTML);
    processCreditTerm();
    setTimeout(() => {
      navigateCreditCond();
    }, 100);
  };

  const onChangeSort = (idx: number) => {
    // 금리/한도 전보 설정
    setSortValue(idx + 1);
    const sort = [
      {
        beacon: { subEventName: ClkBtnSubEventNm.RateRecord, btnName: '금리' },
        sortValue: 'rate',
      },
      {
        beacon: { subEventName: ClkBtnSubEventNm.LimitRecord, btnName: '한도' },
        sortValue: 'limit',
      },
    ];
    sendBeaconClkBtn(sort[idx].beacon.subEventName, sort[idx].beacon.btnName);
  };

  const getPreReqTime =
    moment(regDate, 'YYYY.MM.DD HH:mm:ss').format('YYYY.MM.DD HH:mm') !==
    'Invalid date'
      ? moment(regDate, 'YYYY.MM.DD HH:mm:ss').format('YYYY.MM.DD HH:mm')
      : '0000.00.00 00:00';

  const sheet1 = <InfoTable informs={mtgInfo} direction={'columns'} />;
  const sheet2 = (
    <VisualBox>
      <img src={rateImg} alt={'rate-img'} />
    </VisualBox>
  );

  if (isLoading) {
    return <Skeleton type={'a'}></Skeleton>;
  }

  return (
    <>
      <StackingSnackbar bottom={120} />
      {!hasResult ? (
        <EmptyResultMtg
          getPreReqTime={getPreReqTime}
          onClickMainBtn={onClickRePreReq}
          onClickCreBtn={onClickCreBtn}
        />
      ) : (
        <>
          <HeadTitle
            onClickButton={onClickRePreReq}
            textTitle={'조회 결과'}
            buttonText={'담보 바꿔 조회하기'}
            buttonIconName={'ChevronRightSharp'}
            iconSize={'sm'}
          />

          <FlexBox padding={'20px'} onClick={onClickMtgInfo}>
            <Trg16 text={mtgSummary.mtgNm} />
            <IconBox padding={'0 4px'}>
              <Icon name={'InfoOutlined'} color={'default'} size={'md'} />
            </IconBox>
          </FlexBox>

          <FlexBox padding={'10px 20px'} alignItems={'end'}>
            <ItemContent
              textTitle={`${
                mtgSummary?.minRateProductItem?.interestRate ?? ''
              }%`}
              subTitle={'예상 최저 금리'}
              stress={true}
            />
            <div style={{ width: '32px' }} />
            <ItemContent
              textTitle={
                addUnitToMaxAmount(mtgSummary?.maxAmountProductItem?.amount) ??
                ''
              }
              subTitle={'예상 최대 한도'}
              icon={'HelpOutline'}
              onClickIcon={onClickMaxAmt}
              stress={true}
            />
            {/* <IconBox padding={'2px 4px'} onClick={onClickMaxAmt}>
              <Icon name={'HelpOutline'} color={'default'} size={'md'} />
            </IconBox> */}
          </FlexBox>

          <DefaultBox>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                paddingBottom: '16px',
              }}
            >
              <TextButton
                size={'md'}
                state={'focused'}
                iconRight={{
                  name: 'FilterAltSharp',
                  color: 'default',
                  size: 'md',
                }}
                text="필터"
                onClickButton={() => {
                  setFilterValue(filterValue);
                  setOpenFilter(true);
                }}
              />
            </div>
            <SegmentButtons
              items={[
                { label: '금리', value: 0 },
                { label: '한도', value: 1 },
              ]}
              activeIdx={sortValue - 1}
              onClickButton={(e, { index }) => onChangeSort(index)}
            />
          </DefaultBox>
          <DefaultBox>
            {filteredList?.length > 0 &&
              filteredList?.map((item: any, idx: number) => {
                return (
                  <div key={'f_' + idx + item.preRequestDtlNo}>
                    <DetailItemA
                      textTitle={item.companyNm}
                      subTitle={item.productNm}
                      avatar={{
                        source: item.logoImgUrl,
                        alt: item.companyNm,
                      }}
                      eventChip={item.eventChip}
                      valueA={item.interestRate + '%'}
                      valueB={addUnitToMaxAmount(item.limitValue)}
                      eventText={item.benefitText}
                      onClickDetailItemA={() => handleClickAllProduct(idx)}
                      divider={idx < filteredList.length - 1}
                    />
                  </div>
                );
              })}
            {filteredList?.length <= 0 && (
              <CenterBox>
                <Trg16 text="조건에 맞는 상품이 없어요"></Trg16>
              </CenterBox>
            )}
          </DefaultBox>

          <CenterBox>
            <Button
              onClick={onClickRePreReq}
              flexible={false}
              size={'sm'}
              children={'다른 담보로 다시 조회하기'}
              configuration={'outlined'}
              color={'default'}
            />
          </CenterBox>
          <Divider type={'content'} />

          <SpacerSection
            size={'md'}
            children={
              <>
                <HeadTitle textTitle={'주택 담보 관련 자주 묻는 질문'} />
                <AccordionList
                  list={FAQ.map((item, itemIndex) => {
                    return {
                      title: <Trg16 text={item.title} />,
                      content: (
                        <Wrap key={`faq_${itemIndex}_content`}>
                          {item.content.map((contentItem: any, idx: number) => {
                            return (
                              <div key={idx + 'content'}>
                                {contentItem.title && (
                                  <Tmd14
                                    text={contentItem.title}
                                    color={'#696969'}
                                  />
                                )}
                                {contentItem.description && (
                                  <Trg11
                                    text={contentItem.description}
                                    color={'#696969'}
                                  />
                                )}
                              </div>
                            );
                          })}
                        </Wrap>
                      ),
                    };
                  })}
                />
              </>
            }
          />
          <Divider type={'content'} />

          <SpacerSection
            size={'md'}
            children={
              <FlexBox
                onClick={onClickSurvey}
                padding={'20px'}
                justify={'space-between'}
                style={{ zIndex: 99 }} //  todo 제거
              >
                <Trg16 text={'주택담보대출 결과는 만족하셨나요?'} />
                <Icon
                  name={'ChevronRightSharp'}
                  color={'default'}
                  size={'sm'}
                />
              </FlexBox>
            }
          />

          <TheFooter
            type={'a'}
            onClickOnlineLoanCorp={navigateOnlineLoanCorp}
            onClickOvertake={navigateOvertake}
            onClickOvertakePrivacy={navigateOvertakePrivacy}
          />
        </>
      )}

      <TermFullSheet
        isOpen={termFullsheet.isOpen}
        title={termFullsheet.title}
        path={termFullsheet.path}
        onClickClose={termFullsheet.close}
      />

      <CheckboxBottomsheet
        isOpenCheckBottomsheet={termBottomsheet.isOpen}
        title={'약관에 동의하시면\n 새로운 조건으로 확인해 드릴게요'}
        buttonText={'동의하기'}
        buttonState={termBottomsheet.isActive ? 'enabled' : 'disabled'}
        buttonIsDisabled={!termBottomsheet.isActive}
        checkboxItems={termBottomsheet.checkList}
        onClickCheck={(idx: number) => termBottomsheet.toggleCheckBox(idx)}
        onClickExpand={openTermFullsheet}
        onClickSubText={onClickSubText}
        onClickSubmitButton={(e) => handleClickTermCta(e)}
        onCloseCheckBottomsheet={termBottomsheet.close}
        toast={''}
      />

      <TermFullSheet
        isOpen={creditTermFullsheet.isOpen}
        title={creditTermFullsheet.title}
        path={creditTermFullsheet.path}
        onClickClose={creditTermFullsheet.close}
      />
      <CheckboxBottomsheet
        isOpenCheckBottomsheet={creditTermBottomsheet.isOpen}
        title={'약관에 동의하시면\n 빠르게 비교해 드릴게요'}
        buttonText={'동의하기'}
        buttonState={creditTermBottomsheet.isActive ? 'enabled' : 'disabled'}
        buttonIsDisabled={!creditTermBottomsheet.isActive}
        checkboxItems={creditTermBottomsheet.checkList}
        onClickCheck={(idx: number) =>
          creditTermBottomsheet.toggleCheckBox(idx)
        }
        onClickExpand={openCreditTermFullsheet}
        onClickSubText={onClickCreditSubText}
        onClickSubmitButton={(e) => handleClickCreditTermCta(e)}
        onCloseCheckBottomsheet={creditTermBottomsheet.close}
        toast={''}
      />

      <Bottomsheet
        backdrop={true}
        isOpen={bottomsheet.isOpen}
        isMaxHeight={false}
        children={
          <>
            <HeadTitle
              textTitle={bottomsheet.title}
              buttonIconName={'CloseSharp'}
              onClickButton={bottomsheet.close}
            />
            {bottomsheet.title === '담보 정보' ? sheet1 : sheet2}
            <Spacer size={'md'} />
          </>
        }
      />

      <BridgeModal
        isBridgeModalOpen={isBridgeModal}
        message={'대출비교서비스에서 금융상품으로\n 이동 중이에요'}
        timeout={2000}
        onDone={() => navigateDA(media)}
      />

      <Popup
        title={popup.message}
        isPopupOpen={popup.open}
        confirmBtn={{ text: popup.confirmText, onClick: popup.onClickConfirm }}
        cancelBtn={{ text: popup.cancelText, onClick: popup.onClickCancel }}
      />

      <TheSliderFilterBottomsheet
        defaultValue={filterValue}
        onClose={() => {
          setOpenFilter(false);
        }}
        onConfirm={(_, v) => {
          setFilterValue(v);
          setOpenFilter(false);
        }}
        isSliderFilterBottomsheetOpen={isOpenFilter}
        buttonText={'확인'}
        max={2000000000}
        step={10000000}
      />
    </>
  );
};
